import { gql } from "@apollo/client";

export const GetEmailConfigs = gql`
  query GetEmailConfig($token: String!, $customerId: ID!) {
    GetEmailConfig(token: $token, customerId: $customerId) {
      id
      from
      password
      smtpHost
      smtpPort
      customerID
    }
  }
`;